import { useState } from "react";
import { CampaignServiceError, createCampaign as createCampaignApi } from "../api";
import { CreateCampaignRequest, CreateCampaignResponse } from "../types";

interface UseCreateCampaignResult {
  loading: boolean;
  error: string | null;
  success: boolean;
  createCampaign: (payload: CreateCampaignRequest) => Promise<CreateCampaignResponse>;
  reset: () => void;
}

export function useCreateCampaign(): UseCreateCampaignResult {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const createCampaign = async (
    payload: CreateCampaignRequest
  ): Promise<CreateCampaignResponse> => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await createCampaignApi(payload);
      setSuccess(true);
      return response;
    } catch (submitError) {
      setError(
        submitError instanceof CampaignServiceError || submitError instanceof Error
          ? submitError.message
          : "Failed to create campaign."
      );
      throw submitError;
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setLoading(false);
    setError(null);
    setSuccess(false);
  };

  return {
    loading,
    error,
    success,
    createCampaign,
    reset,
  };
}
